// @flow

import React, { type Node, useMemo } from 'react';
import { getGatewayVoucherUrl, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { SaveAttachmentButton } from '../../../../../commons/molecules';

export function SaveAsPdfButton(): Node {
  const incomingPayment = usePendingIncomingPayment();

  const gatewayVoucherUrl = getGatewayVoucherUrl(incomingPayment);

  const href = useMemo(() => {
    const url = new URL(gatewayVoucherUrl);
    url.searchParams.append('format', 'pdf');
    return url.toString();
  }, [gatewayVoucherUrl]);


  return <SaveAttachmentButton href={href}>Guardar Recibo Efecty en PDF</SaveAttachmentButton>;
}
